export const TOGGLE_SELECTED_ID = 'TOGGLE_SELECTED_ID';
export const TOGGLE_ALL_SELECTED_IDS = 'TOGGLE_ALL_SELECTED_IDS';
export const SET_ALL_IDS = 'SET_ALL_IDS';
